module.exports = __webpack_public_path__ + "img/bochiimg2.65b74162.png";